import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";

const Title = styled("p")(({ theme }) => ({
  width: "100%",
  textAlign: "left",
  paddingLeft: "20px",
  borderBottom: "1px solid #000",
  lineHeight: "0.1em",
  margin: "20px 0 30px"
}));

const TitleText = styled("span")(({ theme }) => ({
  background: "#fff",
  padding: "0 10px",
  fontSize: "16px",
  fontWeight: "600",
  color: "#373737"
}));

/**
 * TitleWithHorizontalLine Component
 *
 * Renders a title with a horizontal line that breaks where the text is displayed
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The content to be displayed as the title
 * @returns {React.ReactElement} The rendered component
 */
export const TitleWithHorizontalLine = props => {
  return (
    <Title role="heading" aria-level="2">
      <TitleText>{props.children}</TitleText>
    </Title>
  );
};

TitleWithHorizontalLine.propTypes = {
  /**
   * The content to be displayed as the title
   */
  children: PropTypes.node.isRequired
};
